var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      { staticClass: "list-group" },
      _vm._l(_vm.scaleLevels, function (l) {
        return _c(
          "button",
          {
            key: l.Value,
            staticClass: "list-group-item list-group-item-action text-left",
            class: { active: l.Value === _vm.value },
            on: {
              click: function ($event) {
                return _vm.updateValue(l.Value)
              },
            },
          },
          [
            _c("i", {
              staticClass: "fa",
              class:
                l.Value === _vm.value ? "fa-check-circle" : "fa-circle-thin",
            }),
            _vm._v(
              "\n            " +
                _vm._s(l.Name) +
                " (" +
                _vm._s(l.Value) +
                ")\n        "
            ),
            l.Definition
              ? _c("p", { staticClass: "mb-0" }, [_vm._v(_vm._s(l.Definition))])
              : _vm._e(),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("textarea", {
      staticClass: "form-control my-3",
      attrs: { rows: "3", placeholder: "Comment..." },
      domProps: { value: _vm.comment },
      on: {
        input: function ($event) {
          return _vm.updateComment($event.target.value)
        },
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }